import { SpaceObjectGroup } from "../../types";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { devtools } from "zustand/middleware";

type FocusType = "Default" | "Conjunction";

export type InteractObject = {
  object: SpaceObjectGroup;
  type: FocusType;
};

type InteractObjectStore = {
  focus: InteractObject;
  // hover: InteractObject;
  setFocus: (sat: SpaceObjectGroup | null, type?: FocusType) => void;
  // setHover: (sat: SpaceObject | null) => void;
};

export const useInteractObjectStore = create<InteractObjectStore>(set => ({
  focus: {
    object: null,
    type: "Default"
  },
  // hover: {
  //   object: null
  // },
  setFocus: (object, type = "Default") => {
    // set({ focus: { object, type } });
    set(state => ({
      ...state,
      focus: { object, type }
    }));
  }
  // setHover: object => {
  //   set({ hover: { object } });
  // }
}));
